import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import AsyncSelect from 'react-select/lib/Async';
import { injectIntl, FormattedMessage } from 'react-intl'

const Wrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 80px;
  max-width: 280px;
  width: 100%;
  z-index: 400;
`

const Content = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #F6F6F6;
  border-radius: 10px;
`

const BoxTitle = styled.h2`
  display: block;
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  color: #65a49e;
`

function filterOptions(options, inputValue) {
  if (inputValue === '' || inputValue.length < 4) { return []; }
  const parsedValue = _.kebabCase(inputValue);

  return _.filter(options, (city) => {
    return _.includes(city.key, parsedValue);
  });
}

const SearchCity = ({ cities, intl, onSelect }) => {
  const loadOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(filterOptions(cities, inputValue));
    }, 1000);
  };

  const handleSelectChange = ({ value }) => {
    if (value) { onSelect(value); }
  };

  return (
    <Wrapper>
      <Content>
        <BoxTitle>
          <FormattedMessage id="layer.opt.mun" />
        </BoxTitle>
        <AsyncSelect
          cacheOptions
          loadOptions={ loadOptions.bind(this) }
          defaultOptions
          onChange={ handleSelectChange.bind(this) }
          placeholder={ intl.formatMessage({ id: 'layer.opt.mun_placeholder' }) }
          loadingMessage={ () => intl.formatMessage({ id: 'layer.opt.loading' }) }
          noOptionsMessage={ () => intl.formatMessage({ id: 'layer.opt.no_option' }) }
        />
      </Content>
    </Wrapper>
  );
};

export default injectIntl(SearchCity)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchCity/SearchCity.js